import { PaymentMethod } from './payment-method.enum';

export const PAYMENT_METHOD_LABEL: Record<PaymentMethod, string> = {
  [PaymentMethod.INVOICE]: 'Rechnung',
  [PaymentMethod.SEPA]: 'SEPA-Lastschrift'
};
